import { PHONE, locationSchema } from "../structured-data-core";

export function getBoulderStructuredData() {
  const url = "https://restorehair.com/locations/colorado/boulder/";
  const description =
    "Find out about your hair transplant options in Boulder with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Boulder", "4770 Baseline Rd, Office 232", "Boulder", "CO", PHONE, url, description),
  ];
}
